(function () {
    function initAllWhereToFind() {
      document
        .querySelectorAll('.where-to-find-items[data-swiper-enabled="true"]')
        .forEach(function (container) {
          // Destroy existing instance if any
          if (container.swiper) {
            try {
              container.swiper.destroy(true, true);
            } catch (e) {}
          }
  
          const nav = container.closest('.where-to-find').querySelector('.where-to-find-nav');
          const prevBtn = nav ? nav.querySelector('.where-to-find-prev') : null;
          const nextBtn = nav ? nav.querySelector('.where-to-find-next') : null;
          const hasNav = prevBtn && nextBtn;
  
          if (nav) {
            nav.classList.toggle('is-visible', hasNav);
          }
  
          container.swiper = new Swiper(container, {
            slidesPerView: 'auto',
            spaceBetween: 16,
            breakpoints: {
              640: { spaceBetween: 20 },
              990: { spaceBetween: 24 }
            },
            navigation: hasNav
              ? { prevEl: prevBtn, nextEl: nextBtn }
              : undefined,
            freeMode: { enabled: true, sticky: false },
            grabCursor: true,
            resistanceRatio: 0.85,
            speed: 400
          });
        });
    }
  
    document.addEventListener('DOMContentLoaded', initAllWhereToFind);
  
    let resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(initAllWhereToFind, 300);
    });
  })();
  